<template>
  <div class="wrapper">
    <div
      class="
        container-fluid
        footer
        d-flex
        justify-content-between
        px-3
        background
        py-3
        text-center text-white
      "
    >
      <div>&copy; Lokpath. All Rights Reserved</div>
      <div>Inky Quill International Pvt. Ltd</div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.background {
  background-color: var(--color_secondary);
}
</style>
